import React, { useState, useContext, useEffect, useRef } from "react";
import styles from "./styles/Search.module.css";
import Carousel from "../../components/ui/carousel/Carousel";
import DataContext from "../../context/DataContext";
import Button from "../../components/ui/button/Button";
import useWindowSize from "../../hooks/useWindowSize";

import useRefDimensions from "../../hooks/useRefDimensions";
import { useTranslation } from "react-i18next";

/**
 * PhotoPanel component
 */
const PhotoPanel = ({
    ticket, // {Object} - Ticket data.
}) => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const windowSize = useWindowSize();
    const carouselRef = useRef(null);
    const carouselSize = useRefDimensions(carouselRef);
    const { currentCategory, setCurrentCategory } = useContext(DataContext);
    const { t } = useTranslation();

    // Check for full screen mode
    useEffect(() => {
        const checkFullscreen = () => {
            const isFullscreen =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            setIsFullscreen(!!isFullscreen);
        };

        document.addEventListener("fullscreenchange", checkFullscreen);
        document.addEventListener("webkitfullscreenchange", checkFullscreen);
        document.addEventListener("mozfullscreenchange", checkFullscreen);
        document.addEventListener("MSFullscreenChange", checkFullscreen);

        // Full screen initial check
        checkFullscreen();

        return () => {
            document.removeEventListener("fullscreenchange", checkFullscreen);
            document.removeEventListener(
                "webkitfullscreenchange",
                checkFullscreen,
            );
            document.removeEventListener(
                "mozfullscreenchange",
                checkFullscreen,
            );
            document.removeEventListener("MSFullscreenChange", checkFullscreen);
        };
    }, []);

    /**
     * Category handle
     */
    const handleCategory = (event) => {
        setCurrentCategory(event.target.dataset.ex);
    };

    /**
     * Return all the categories for the current ticket
     * @param {Object} obj - Ticket data
     * @returns {Array} - Photo categories
     */
    const getCategories = (obj) => {
        const tempCategories = [];
        obj?.map((photo) => {
            !tempCategories.includes(photo?.category) &&
                tempCategories.push(photo?.category);
        });
        return tempCategories;
    };

    return (
        <section
            className={`${styles.main_info_container} ${styles.main_photo_container} `}
            ref={carouselRef}
        >
            <div className={`${styles.categories_container} `}>
                {getCategories(ticket?.photos).map((category, idx) => (
                    <Button
                        data={category}
                        key={category}
                        body={t(category)}
                        size={"small"}
                        type={"button"}
                        onClickFuction={handleCategory}
                        active={currentCategory === category}
                    />
                ))}
            </div>
            <div className={`${styles.carousel_container} `}>
                <Carousel
                    images={ticket?.photos
                        ?.filter((photo) => photo?.category === currentCategory)
                        ?.map((photo) => {
                            return {
                                original: photo?.picture,
                                thumbnail: photo?.picture,
                                originalAlt: `Evidence photo, category ${currentCategory}`,
                                thumbnailAlt: `Evidence photo, category ${currentCategory}`,
                                // The originalHeight is set to 31% of the carousel width if not in full screen mode
                                originalHeight: !isFullscreen
                                    ? carouselSize.width -
                                      (carouselSize.width * 31) / 100
                                    : null,
                            };
                        })}
                    showThumbnails={
                        // Show thumbnails if the screen is not full screen or the screen width is larger than 768px
                        isFullscreen || windowSize.width <= 768 ? false : true
                    }
                    // Show bullets if the screen is full screen or the screen width is less than 768px
                    showBullets={
                        isFullscreen || windowSize.width <= 768 ? true : false
                    }
                />
            </div>
        </section>
    );
};

export default PhotoPanel;
